// extracted by mini-css-extract-plugin
module.exports = {"button":"Note__button___724hv","button__icon":"Note__button__icon___1Qd96","content":"Note__content___3R2kW","edit":"Note__edit___ZAx7o"};